import { AbstractControl, ValidatorFn } from '@angular/forms'

export const URL_REGEX = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i

export function urlValid(url: string): boolean {
  return !!url.match(URL_REGEX)
}

export function twitterValid(handle: string): boolean {
  return !!handle.match(/^[a-zA-Z0-9_]{1,15}$/)
}

export function facebookUsernameValid(username: string): boolean {
  return !!username.match(/^[a-z\d.]{5,}$/i)
}

export function emailValid(email: string): boolean {
  return email && !!email.match(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)
}

export class ValidationService {

  static getValidatorErrorMessage(code: string) {
    let config = {
      'invalidUrl': 'Invalid Url',
      'invalidTwitterHandle': 'Invalid Twitter Handle',
    }
    return config[code]
  }

  static urlValidator: ValidatorFn = (control: AbstractControl) => {
    if (!control || !control.value || control.value === '' || urlValid(control.value)) {
      return null
    } else {
      return { 'invalidUrl' : true }
    }
  }

  static checkBoxCheckedValidator: ValidatorFn = (control: AbstractControl) => {
    if (control && control.value === true) {
      return null
    } else {
      return { 'mustBeTrue': true }
    }
  }

  static twitterHandleValidator: ValidatorFn = (control: AbstractControl) => {
    if (!control || !control.value || control.value === '' || twitterValid(control.value)) {
      return null
    } else {
      return { 'invalidTwitterHandle' : true }
    }
  }

  static facebookUsernameValidator: ValidatorFn = (control: AbstractControl) => {
    if (!control || !control.value || control.value === '' || facebookUsernameValid(control.value)) {
      return null
    } else {
      return { 'invalidFacebookUsername' : true }
    }
  }

  static emailValidator: ValidatorFn = (control: AbstractControl) => {
    if (!control || !control.value || control.value === '' || emailValid(control.value))
      return null
    else
      return { 'invalidEmail': true }
  }

}
